export const TOOL_ENTRIES_EN = [
  {
    label: 'Audio to Text Converter',
    url: '/en/tools/audio-to-text-converter',
  },
  {
    label: 'Online Video Converter',
    url: '/en/tools/online-video-converter',
  },
  {
    label: 'Online Audio Converter',
    url: '/en/tools/online-audio-converter',
  },
  {
    label: 'Online Vocal Remover',
    url: '/en/tools/online-vocal-remover',
  },
];

export const TOOL_ENTRIES_JA = [
  {
    label: 'オンライン音声文字起こしコンバター',
    url: '/tools/audio-to-text-converter',
  },
  {
    label: 'フリーオンライン動画変換',
    url: '/tools/online-video-converter',
  },
  {
    label: 'オンライン音声変換',
    url: '/tools/online-audio-converter',
  },
  {
    label: 'ボーカルリムーバー',
    url: '/tools/online-vocal-remover',
  },
];

export const USE_CASES_ENTRIES_JA = [
  {
    label: '聴覚障がい者',
    url: '/use-cases/hearing-impaired',
  },
  {
    label: '営業担当',
    url: '/use-cases/business',
  },
  {
    label: 'ライター',
    url: '/use-cases/writer',
  },
  {
    label: '学生',
    url: '/use-cases/student',
  },
];
